import {Typography} from '@material-ui/core';
import React, {ReactElement} from 'react';
import Layout from '../components/Layout';

const NotFound = () : ReactElement => (
    <Layout>
        <Typography variant="h4">File not found</Typography>
        <Typography variant="body1">
            The requested file could not be found.
        </Typography>
    </Layout>
);

export default NotFound;
